import { FC, ReactNode } from 'react';
import { SkeletonFilters } from '../SkeletonList';
import styles from './RoomTypeFilter.css';

interface IRoomTypeFilterProps {
  options: ReactNode;
  showSkeletonFilters: boolean;
}

export const RoomTypeFilter: FC<IRoomTypeFilterProps> = ({ options, showSkeletonFilters }) => {
  return (
    <div className={styles['room-type-filter']}>
      {options}
      {/** Накладываем скелетон сверху, чтобы подскролл к чипсах на мобвебе работал корректно */}
      {showSkeletonFilters && (
        <div className={styles['skeleton-filter']}>
          <SkeletonFilters />
        </div>
      )}
    </div>
  );
};
